export const NOTIFICATION_API_URL = '/api/notification-center'
